import { CreateExternalLinkTo, CreateLinkTo, LinkTo } from "../../constants/linkTo";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { bURL } from "../../../core";
import { useGetMyCoursesTabs } from "./tabs/useGetMyCoursesTabs";
import { useGetCompetitionTabs } from "./tabs/useGetCompetitionTabs";
import { useGetShopTabs } from "./tabs/useGetShopTabs";
import { useGetOnlinesDesignTabs } from "./tabs/useGetOnlinesDesignTabs";
import { useGGRaveTabs } from "./tabs/useGGRaveTabs";
import { useGetHseColorsTabs } from "./tabs/useGetHseColorsTabs";
import { useGetHseOnlineTabs } from "./tabs/useGetHseOnlineTabs";
import { useGetAmSchoolTabs } from "./tabs/useGetAmSchoolTabs";
import { useGetAboutTabs } from "./tabs/useGetAboutTabs";
import { useGetTagTabs } from "./tabs/useGetTagTabs";
import { ComingSoonTab } from "./components/ComingSoonTab";
import { AppTester } from "../../../supporting";
import { useGetBrndTabs } from "./tabs/useGetBrndTabs";
import { NAVBAR_TAB_NAMES } from "./const/navbarTabNames";
import { usePortfolio365Tabs } from "./tabs/usePortfolio365Tabs";
import useDafesTabs from "./tabs/useDafesTabs";
import { useKiiidsArtTabs } from "./tabs/useKiiidsArtTabs";
import { FlexBox } from "@brg/ui";

export const useGetTabsList = () => {

    const location = useLocation();
    const history = useHistory();
    const { t, i18n: {language} } = useTranslation();
    const isMap = useRouteMatch('/map');

    const myCoursesTabs = useGetMyCoursesTabs()
    const competitionTabs = useGetCompetitionTabs()
    const shopTabs = useGetShopTabs()
    const aboutTabs = useGetAboutTabs()
    const brndTabs = useGetBrndTabs()
    const onlinesDesignTabs = useGetOnlinesDesignTabs()
    const hseColorsTabs = useGetHseColorsTabs()
    const hseOnlineTabs = useGetHseOnlineTabs()
    const amSchoolTabs = useGetAmSchoolTabs()
    const cgRaveTabs = useGGRaveTabs()
    const portfolio365Tabs = usePortfolio365Tabs();
    const kiiidsArtTabs = useKiiidsArtTabs()
    const dafesTabs = useDafesTabs();
    const tagTabs = useGetTagTabs()
    const { pathname } = location;
    const isAgeyTomesh = AppTester.isAgeytomesh();
    const isHseAnimation = AppTester.isHseAnimation();
    const isProHSE = AppTester.isProHSE();
    const isContinuumSite = AppTester.isContinuumSite();
    const isBooksMain = AppTester.isBooksDeziiign()
    const isBooksGallllery = AppTester.isBooksGallllery()
    const isStartHSE = AppTester.isStartHSE();
    const isAdditionalBookRoute = useRouteMatch('/books/book')
    const isMediiiaBooks = AppTester.isMediiia() && (window.location.pathname.startsWith('/mediiiabooks') || isAdditionalBookRoute)
    const isMediiiaUrban = AppTester.isMediiiaUrban()
    const isLectureMediiia = AppTester.isLectureMediiia()
    const isMediiiaNature = AppTester.isMediiiaNature()
    const isMediiiaEvents = AppTester.isEventMediiia()
    const isCompetitionDeziiign = AppTester.isCompetition()
    const isDeziiignMain = AppTester.isDeziiignMain()
    const isLMSHSE = AppTester.isLMSHSE();
    const isHSEDesign = AppTester.isContext('hsedesign')
    const isHseSpacePro = AppTester.isContext('s-pro')
    const isHsetto = AppTester.isContext('s-hsetto')
    const isMediiiaArt = AppTester.isMediiiaArt()
    const isMediiia = AppTester.isMediiia()

    //TO DO из всего этого надо будет как-то убирать экшны и переносить адреса в linkTo, при этом изменив работу компонента ссылок в ui

    return {
        ...onlinesDesignTabs,
        ...hseOnlineTabs,
        ...hseColorsTabs,
        ...amSchoolTabs,
        ...brndTabs,
        ...cgRaveTabs,
        ...portfolio365Tabs,
        ...kiiidsArtTabs,
        ...dafesTabs,
        [NAVBAR_TAB_NAMES.studios]: {
            active: pathname.startsWith(LinkTo.studios),
            content: t('nav.studios'),
            target: '_self',
            linkTo: () => {
                if (isCompetitionDeziiign) {
                    return CreateExternalLinkTo.deziiign(LinkTo.studios);
                }
                return LinkTo.studios;
            },
        },
        [NAVBAR_TAB_NAMES.genres]: {
            content: t('nav.genres'),
            linkTo: LinkTo.tagCompetencies,
        },
        [NAVBAR_TAB_NAMES.authors]: {
            content: <ComingSoonTab>авторы</ComingSoonTab>,
            disabled: true,
        },
        [NAVBAR_TAB_NAMES.publishingHouse]: {
            content: <ComingSoonTab>издательства</ComingSoonTab>,
            disabled: true,
        },
        [NAVBAR_TAB_NAMES.coursesContinium]: {
            active: location.pathname === '/',
            disabled: true,
            content: <ComingSoonTab>курсы</ComingSoonTab>,
        },
        [NAVBAR_TAB_NAMES.my_books]: {
            content: t('nav.my_books'),
            linkTo: LinkTo.myBooks,
        },
        [NAVBAR_TAB_NAMES.portfolio]: isLMSHSE ? {
            content: t('nav.portfolio'),
            linkTo: process.env.REACT_APP_URL_HSEDESIGN_RU,
            target: '_self',
        } : isMediiiaArt ? {
            content: t('nav.portfolio'),
            linkTo: `/portfolio`,
        } : {
            active: location.pathname === '/',
            content: t('nav.portfolio'),
            linkTo: `/`,
        },
        [NAVBAR_TAB_NAMES.portfolio_deziiign_external]: {
            content: t('nav.portfolio'),
            linkTo: CreateExternalLinkTo.deziiign(),
            target: '_self',
        },
        [NAVBAR_TAB_NAMES.courses]: {
            disabled: isContinuumSite,
            content: t('nav.all_courses'),
            linkTo: '/',
        },
        [NAVBAR_TAB_NAMES.all_courses]: {
            content: t('nav.all_courses'),
            linkTo: '/',
        },
        [NAVBAR_TAB_NAMES.courses_offline]: {
            content: t('nav.offline_courses'),
            linkTo: '/courses_offline',
        },
        [NAVBAR_TAB_NAMES.courses_online]: {
            active: isLectureMediiia ? location.pathname === '/courses_online' || location.pathname === '/' : location.pathname === '/courses_online',
            content: t('nav.online_courses'),
            linkTo: '/courses_online',
        },
        [NAVBAR_TAB_NAMES.courses_lms]: {
            content: t('nav.courses'),
            external: true,
            linkTo: window.location.origin.includes("com") ? process.env.REACT_APP_URL_HSEDESIGN_LMS_COM : process.env.REACT_APP_URL_HSEDESIGN_LMS,
            target: '_self',
        },
        [NAVBAR_TAB_NAMES.courses_lmshse]: {
            content: t('nav.all_courses'),
            external: true,
            linkTo: window.location.origin.includes("com") ? process.env.REACT_APP_URL_HSEDESIGN_LMS_COM : process.env.REACT_APP_URL_HSEDESIGN_LMS,
            target: '_self',
        },
        [NAVBAR_TAB_NAMES.metrics]: {
            content: t('nav.metrics'),
            external: true,
            linkTo: `${process.env.REACT_APP_URL_HSEDESIGN_RU}/metrics`,
            target: '_self',
        },
        [NAVBAR_TAB_NAMES.custom_courses]: {
            content: t('nav.courses'),
            linkTo: '/lms',
        },
        ...tagTabs,
        [NAVBAR_TAB_NAMES.artpublishing]: {
            active: location.pathname === '/teams/artpublishing',
            content: t('nav.artpublishing'),
            linkTo: CreateExternalLinkTo.gallllery('/books?page=1'),
            target: '_blank',
        },
        [NAVBAR_TAB_NAMES.subscription]: {
            content: t('nav.subscription'),
            linkTo: '/teams/artpublishing/brnd',
        },
        [NAVBAR_TAB_NAMES.artists]: {
            linkTo: '/tag/category/12545e352cb24ab5985ecf9c084e47f6',
            content: t('nav.catalogs'),
        },
        [NAVBAR_TAB_NAMES.lms]: {
            content: t('nav.education'),
            linkTo: '/lms',
        },
        [NAVBAR_TAB_NAMES.people]: {
            content: t('nav.people'),
            active: location.pathname.startsWith('/context/hse/teachers') ||
                location.pathname.startsWith('/context/hse/students') ||
                location.pathname.startsWith('/context/hse/opa') ||
                location.pathname.startsWith('/context/hse/opa_by_month'),
            linkTo: '/context/hse/teachers',
        },
        [NAVBAR_TAB_NAMES.professors]: {
            content: t('nav.professors'),
            active: location.pathname.startsWith('/context/hse/teachers') ||
                location.pathname.startsWith('/context/hse/students') ||
                location.pathname.startsWith('/context/hse/opa') ||
                location.pathname.startsWith('/context/hse/opa_by_month'),
            linkTo: '/context/hse/teachers',
        },
        [NAVBAR_TAB_NAMES.students]: {
            content: t('nav.students'),
            active: location.pathname.startsWith('/context/hse/students'),
            linkTo: '/context/hse/students',
        },
        [NAVBAR_TAB_NAMES.publishers]: {
            content: t('nav.publishers'),
            linkTo: LinkTo.specialProjects,
        },
        [NAVBAR_TAB_NAMES.special_projects]: {
            linkTo: LinkTo.specialProjects,
            content: () => {
                if (isMediiiaEvents) {
                    return t('nav.special_projects_gifts')
                }
                if (isMediiiaUrban) {
                    return t('nav.special_projects_studios')
                }
                if (isMediiiaBooks) {
                    return t('nav.special_projects_books')
                }
                if (isMediiiaNature) {
                    return t('nav.special_projects_astro')
                }
                return t('nav.special_projects')
            },
        },
        [NAVBAR_TAB_NAMES.special_projects_main]: {
            content: t('nav.special_projects'),
            linkTo: '/',
        },
        [NAVBAR_TAB_NAMES.laboratory]: {
            active: pathname === '/laboratories',
            content: t('nav.laboratory').toLowerCase(),
            linkTo: () => {

                if (isProHSE) {
                    return process.env.REACT_APP_URL_HSEDESIGN_RU + `/laboratories`
                }

                return `/laboratories`
            },
            target: '_self',
        },
        [NAVBAR_TAB_NAMES.fantasy_sport]: {
            active: pathname === '/fantasy_sport',
            content: <ComingSoonTab>fantasy sport</ComingSoonTab>,
            disabled: true,
        },
        [NAVBAR_TAB_NAMES.lpu_awards]: {
            active: pathname === '/awards',
            content: <ComingSoonTab>awards</ComingSoonTab>,
            disabled: true,
        },
        [NAVBAR_TAB_NAMES.timeline]: {
            content: t("nav.timeline"),
            linkTo: '/timeline',
        },
        [NAVBAR_TAB_NAMES.gallllery]: {
            content: t("nav.gallllery"),
            linkTo: '/galleries',
        },
        [NAVBAR_TAB_NAMES.e_books]: {
            active: pathname === 'e_books' || (isBooksGallllery && window.location.pathname.endsWith('/')),
            content: (isAgeyTomesh || isHseAnimation || isContinuumSite) ? <ComingSoonTab>e-books</ComingSoonTab> : (isBooksGallllery ? t("nav.e_books") : "e-books"),
            linkTo: process.env.REACT_APP_URL_BOOKS_GALLLLERY,
            target: isDeziiignMain ? '_blank' : '_self',
            disabled: isAgeyTomesh || isHseAnimation || isContinuumSite
        },
        ...(!isBooksMain ? competitionTabs : {}),
        ...myCoursesTabs,
        ...shopTabs,
        [NAVBAR_TAB_NAMES.wallet]: {
            content: t('nav.wallet'),
            linkTo: process.env.REACT_APP_URL_WALLET,
            target: '_blank',
        },
        [NAVBAR_TAB_NAMES.partners]: {
            content: t('nav.partners'),
            linkTo: '/partners',
        },
        [NAVBAR_TAB_NAMES.fund]: {
            content: t('nav.fund'),
            linkTo: '/fund',
        },
        [NAVBAR_TAB_NAMES.festival]: {
            content: t('nav.festival'),
            linkTo: '/festival/Diploma25',
        },
        [NAVBAR_TAB_NAMES.map]: {
            active: Boolean(isMap),
            content: t('nav.map').toLowerCase(),
            linkTo: CreateLinkTo.map(
                bURL.saveVariablesToURIComponent({
                    display: "map",
                    force: true,
                })
            )
        },
        [NAVBAR_TAB_NAMES.competitionsForContinuum]: {
            content: <ComingSoonTab>конкурсы</ComingSoonTab>,
            active: false,
            disabled: true
        },
        [NAVBAR_TAB_NAMES.create_place]: {
            content: t('nav.create_place').toLowerCase(),
            linkTo: LinkTo.createLocation,
        },
        [NAVBAR_TAB_NAMES.sound_deziiign]: {
            content: "sound design",
            linkTo: 'https://design.hse.ru/dir/sound',
            target: '_blank',
        },
        [NAVBAR_TAB_NAMES.sound_lab]: {
            content: "sound lab",
            linkTo: 'https://design.hse.ru/lab/sounddesign#feedback',
            target: '_blank',
        },
        ...aboutTabs,
        [NAVBAR_TAB_NAMES.about_school]: isHSEDesign ? {
            content: t('nav.about_school'),
            linkTo: '/about_school',
        } : {
            content: isStartHSE ? t('nav.about_art_school') : t('nav.about_school'),
            linkTo: 'https://design.hse.ru/',
            external: true,
        },
        [NAVBAR_TAB_NAMES.about_ifcid]: {
            content: t('nav.about_ifcid'),
            active: false,
            linkTo: 'https://creative.hse.ru/',
            target: '_blank',
        },
        [NAVBAR_TAB_NAMES.made_on_media]: {
            content: t('nav.mediiia.made_by_mediiia'),
            linkTo: '/made_by_mediiia',
        },
        [NAVBAR_TAB_NAMES.coordinationCouncil]: {
            content: t('nav.coordinationCouncil'),
            linkTo: '/teams/dafes-council',
        },
        [NAVBAR_TAB_NAMES.news]: {
            content: t('nav.news'),
            linkTo: '/news',
        },
        [NAVBAR_TAB_NAMES.brands]: {
            content: t('nav.brands_simple'),
            linkTo: '/brands',
        },
        [NAVBAR_TAB_NAMES.residents]: {
            content: t('nav.residents'),
            linkTo: '/ud-residents',
        },
        [NAVBAR_TAB_NAMES.experts]: {
            content: t('nav.expert'),
            linkTo: '/ud-experts',
        },
        [NAVBAR_TAB_NAMES.education]: {
            content: t('nav.education'),
            linkTo: '/education',
        },
        [NAVBAR_TAB_NAMES.institutions]: {
            content: t('nav.institutions'),
            linkTo: '/institutions',
        },
        [NAVBAR_TAB_NAMES.partnerUniversities]: {
            active: pathname === '/teams/565f6fae5fcf4306a2ad9c85a3abe367' || pathname === '/partners',
            content: t('nav.partnerUniversities'),
            linkTo: '/partners',
        },
        [NAVBAR_TAB_NAMES.calendar]: {
            active: pathname === '/sport' || pathname === '/',
            content: t('nav.calendar'),
            linkTo: '/',
        },
        [NAVBAR_TAB_NAMES.professions]: {
            content: t('nav.professions'),
            linkTo: '/professions',
        },
        [NAVBAR_TAB_NAMES.sport_sports]: { // Бывший "темы"
            active: pathname === ('/sport/competencies') || pathname === ('/competencies'),
            content: t('nav.sports'),
            linkTo: '/competencies',
        },
        [NAVBAR_TAB_NAMES.sport_teams]: { // Бывший "теги"
            active: pathname === ('/sport/tags') || pathname === ('/tags'),
            content: t('nav.teams'),
            linkTo: '/tags',
        },
        [NAVBAR_TAB_NAMES.sport_leagues]: {
            active: pathname.startsWith('/teams') || pathname.startsWith('/leagues'),
            content: t('nav.leagues'),
            linkTo: '/leagues',
        },
        [NAVBAR_TAB_NAMES.sport_ratings]: {
            active: pathname.startsWith('/sport/ratings') || pathname.startsWith('/ratings'),
            content: t('nav.ratings'),
            linkTo: '/ratings',
        },
        [NAVBAR_TAB_NAMES.about_the_project]: {
            active: pathname.startsWith('/about_the_project'),
            content: <ComingSoonTab>{t('nav.about_project')}</ComingSoonTab>,
            disabled: true
        },
        [NAVBAR_TAB_NAMES.community]: {
            active: pathname.startsWith('/community'),
            content: <ComingSoonTab>{t('nav.community')}</ComingSoonTab>,
            disabled: true
        },
        [NAVBAR_TAB_NAMES.tracks_and_nominations]: {
            active: pathname === '/nominations' || pathname === '/',
            content: t('nav.tracks_and_nominations'),
            linkTo: '/nominations?tab=greenaward&page=1',
        },
        [NAVBAR_TAB_NAMES.results_of_previous_years]: {
            active: pathname.startsWith('/results'),
            content: t('nav.results_of_previous_years'),
            linkTo: '/results?tab=lastgreenaward&sorting=5&page=1',
        },

        [NAVBAR_TAB_NAMES.adcr_awards]: {
            active: pathname.startsWith('/awards'),
            content: t('nav.adcr_awards'),
            linkTo: '/awards?contexts=adcrawards',
        },
        [NAVBAR_TAB_NAMES.animation_awards]: {
            active: pathname.startsWith('/awards'),
            content: t('nav.awards_hsespace'),
            linkTo: 'https://hsedesign.ru/awards?page=1&tab=main_hse',
            target: '_self',
        },
        [NAVBAR_TAB_NAMES.club_members]: {
            content: t('nav.club_members'),
            linkTo: '/clubmembers',
        },
        [NAVBAR_TAB_NAMES.agencies_and_studios]: {
            content: t('nav.agencies_and_studios'),
            linkTo: '/studios',
        },
        [NAVBAR_TAB_NAMES.winners]: {
            content: t('nav.winners'),
            linkTo: '/winners',
        },
        [NAVBAR_TAB_NAMES.units]: {
            content: t('nav.units'),
            linkTo: isHseSpacePro ? `${process.env.REACT_APP_URL_HSE_SPACE}/units` : '/units',
        },
        [NAVBAR_TAB_NAMES.presentation]: {
            content: t('nav.presentation'),
            linkTo: CreateExternalLinkTo.hseSpace('/pro'),
            target: '_self'
        },
        [NAVBAR_TAB_NAMES.awardsHseSpace]: {
            content: t('nav.awards_hsespace'),
            linkTo:  isHseSpacePro ? `${process.env.REACT_APP_URL_HSE_SPACE}/awards` : '/awards',
        },
        [NAVBAR_TAB_NAMES.coursesHseSpace]: {
            active: pathname.startsWith('/courses'),
            content: t('nav.education'),
            linkTo: isHseSpacePro ? `${process.env.REACT_APP_URL_HSE_SPACE}/courses` : '/courses',
        },
        [NAVBAR_TAB_NAMES.categories]: {
            content: t('nav.categories'),
            linkTo: isHseSpacePro ? `${process.env.REACT_APP_URL_HSE_SPACE}/categories` : '/categories',
        },
        [NAVBAR_TAB_NAMES.books_gallllery]: {
            content: t('nav.books_gallllery'),
            linkTo: CreateExternalLinkTo.gallllery('/books?page=1'),
            target: '_self',
        },
        [NAVBAR_TAB_NAMES.calendars]: {
            active: false,
            external: true,
            content:
                <FlexBox align='center' style={{ paddingLeft: 0 }}>
                    <span style={{ marginRight: 2 }}>
                        {t('nav.calendars')}
                    </span>
                    <span style={{ transform: 'translateY(3px)' }}>↗</span>
                </FlexBox>
            ,
            linkTo: 'https://gallllery.com/365',
            target: '_blank',
        },
        [NAVBAR_TAB_NAMES.bookshops]: {
            content: t('nav.bookshops'),
            linkTo: '/bookshops',
        },
        [NAVBAR_TAB_NAMES.shop_gallllery]: {
            content: t('nav.shop'),
            linkTo: isMediiiaNature ? CreateExternalLinkTo.shopBrands('/?page=1&team=c3f512846d3b4a889f2d4f11a19fedf0') : CreateExternalLinkTo.gallllery('/books'),
            target: '_blank',
        },
        [NAVBAR_TAB_NAMES.sellers]: {
            content: t('nav.sellers'),
            linkTo: LinkTo.specialProjects,
        },
        [NAVBAR_TAB_NAMES.awards_booksgallery]: {
            active: pathname.startsWith('/awards'),
            content: t('nav.awards_hsespace'),
            linkTo: '/awards?contexts=/booksmediiiawards',
        },
        [NAVBAR_TAB_NAMES.deziiignresidents]: {
            active: pathname.startsWith('/teams/deziiignresidents'),
            content: t('nav.residents'),
            linkTo: () => {
                if (isCompetitionDeziiign) {
                    return CreateExternalLinkTo.deziiign('/teams/deziiignresidents');
                }
                return '/teams/deziiignresidents';
            },
            target: '_self',
        },
        [NAVBAR_TAB_NAMES.concept]: {
            content: t('nav.concept'),
            linkTo: '/concept',
        },
        [NAVBAR_TAB_NAMES.vacancies]: {
            active: false,
            content: <ComingSoonTab>{t('nav.vacancies')}</ComingSoonTab>,
            disabled: true,
        },
        [NAVBAR_TAB_NAMES.courses_lab]: {
            active: false,
            content: t('nav.courses_lab'),
            linkTo: CreateExternalLinkTo.deziiign('/courses')
        },
        [NAVBAR_TAB_NAMES.main_courses]: {
            active: pathname.startsWith('/courses'),
            content: isMediiia || isDeziiignMain ? t('nav.education') : t('nav.courses'),
            linkTo: '/courses',
        },
        [NAVBAR_TAB_NAMES.studios_deziiign]: {
            active: pathname === '/teams/7cb1b10a81a14667820120db9b9f334d',
            content: t('nav.studios'),
            linkTo: '/teams/7cb1b10a81a14667820120db9b9f334d',
        },
        [NAVBAR_TAB_NAMES.diplomas]: {
            active: pathname === '/teams/c0ac0a5cecf34bb5b30eea1d1d9ab721',
            content: t('nav.diplomas'),
            linkTo: '/teams/c0ac0a5cecf34bb5b30eea1d1d9ab721',
        },
        [NAVBAR_TAB_NAMES.about_hse_start]: {
            active: pathname === '/about',
            content: t('nav.about_hse_start'),
            linkTo: '/about',
        },
        [NAVBAR_TAB_NAMES.creative_exam]: {
            active: pathname === '/creativeexam',
            content: t('nav.creativeexam'),
            linkTo: '/creativeexam',
        },
        [NAVBAR_TAB_NAMES.admission_preparation]: {
            active: pathname === '/preparation',
            content: t('nav.preparation'),
            linkTo: '/preparation',
        },
        [NAVBAR_TAB_NAMES.opportunities]: {
            active: pathname === '/opportunities',
            content: t('nav.opportunities'),
            linkTo: '/opportunities',
        },
        [NAVBAR_TAB_NAMES.news_hse_start]: {
            active: pathname === '/startnews',
            content: t('nav.news'),
            linkTo: '/startnews',
        },
        [NAVBAR_TAB_NAMES.category_start_hse]: {
            active: pathname === '/tag/category/1cb7361e773b44899237d633ee9da5b5',
            content: t('nav.profiles_low'),
            linkTo: '/tag/category/1cb7361e773b44899237d633ee9da5b5',
        },
        [NAVBAR_TAB_NAMES.russiangallllery]: {
            active: pathname === '/russian',
            content: t('nav.russiangallllery'),
            linkTo: '/russian',
        },
        [NAVBAR_TAB_NAMES.awards_start]: {
            active: pathname === '/awards',
            content: <ComingSoonTab>{t('nav.competitions')}</ComingSoonTab>,
            linkTo: '/awards',
            disabled: true
        },
    }
}import { CreateExternalLinkTo, CreateLinkTo, LinkTo } from "../../constants/linkTo";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { bURL } from "../../../core";
import { useGetMyCoursesTabs } from "./tabs/useGetMyCoursesTabs";
import { useGetCompetitionTabs } from "./tabs/useGetCompetitionTabs";
import { useGetShopTabs } from "./tabs/useGetShopTabs";
import { useGetOnlinesDesignTabs } from "./tabs/useGetOnlinesDesignTabs";
import { useGGRaveTabs } from "./tabs/useGGRaveTabs";
import { useGetHseColorsTabs } from "./tabs/useGetHseColorsTabs";
import { useGetHseOnlineTabs } from "./tabs/useGetHseOnlineTabs";
import { useGetAmSchoolTabs } from "./tabs/useGetAmSchoolTabs";
import { useGetAboutTabs } from "./tabs/useGetAboutTabs";
import { useGetTagTabs } from "./tabs/useGetTagTabs";
import { ComingSoonTab } from "./components/ComingSoonTab";
import { AppTester } from "../../../supporting";
import { useGetBrndTabs } from "./tabs/useGetBrndTabs";
import { NAVBAR_TAB_NAMES } from "./const/navbarTabNames";
import { usePortfolio365Tabs } from "./tabs/usePortfolio365Tabs";
import useDafesTabs from "./tabs/useDafesTabs";
import { useKiiidsArtTabs } from "./tabs/useKiiidsArtTabs";
import { FlexBox } from "@brg/ui";

export const useGetTabsList = () => {

    const location = useLocation();
    const history = useHistory();
    const { t, i18n: {language} } = useTranslation();
    const isMap = useRouteMatch('/map');

    const myCoursesTabs = useGetMyCoursesTabs()
    const competitionTabs = useGetCompetitionTabs()
    const shopTabs = useGetShopTabs()
    const aboutTabs = useGetAboutTabs()
    const brndTabs = useGetBrndTabs()
    const onlinesDesignTabs = useGetOnlinesDesignTabs()
    const hseColorsTabs = useGetHseColorsTabs()
    const hseOnlineTabs = useGetHseOnlineTabs()
    const amSchoolTabs = useGetAmSchoolTabs()
    const cgRaveTabs = useGGRaveTabs()
    const portfolio365Tabs = usePortfolio365Tabs();
    const kiiidsArtTabs = useKiiidsArtTabs()
    const dafesTabs = useDafesTabs();
    const tagTabs = useGetTagTabs()
    const { pathname } = location;
    const isAgeyTomesh = AppTester.isAgeytomesh();
    const isHseAnimation = AppTester.isHseAnimation();
    const isProHSE = AppTester.isProHSE();
    const isContinuumSite = AppTester.isContinuumSite();
    const isBooksMain = AppTester.isBooksDeziiign()
    const isBooksGallllery = AppTester.isBooksGallllery()
    const isStartHSE = AppTester.isStartHSE();
    const isAdditionalBookRoute = useRouteMatch('/books/book')
    const isMediiiaBooks = AppTester.isMediiia() && (window.location.pathname.startsWith('/mediiiabooks') || isAdditionalBookRoute)
    const isMediiiaUrban = AppTester.isMediiiaUrban()
    const isLectureMediiia = AppTester.isLectureMediiia()
    const isMediiiaNature = AppTester.isMediiiaNature()
    const isMediiiaEvents = AppTester.isEventMediiia()
    const isCompetitionDeziiign = AppTester.isCompetition()
    const isDeziiignMain = AppTester.isDeziiignMain()
    const isLMSHSE = AppTester.isLMSHSE();
    const isHSEDesign = AppTester.isContext('hsedesign')
    const isHseSpacePro = AppTester.isContext('s-pro')
    const isHsetto = AppTester.isContext('s-hsetto')
    const isMediiiaArt = AppTester.isMediiiaArt()
    const isMediiia = AppTester.isMediiia()

    //TO DO из всего этого надо будет как-то убирать экшны и переносить адреса в linkTo, при этом изменив работу компонента ссылок в ui

    return {
        ...onlinesDesignTabs,
        ...hseOnlineTabs,
        ...hseColorsTabs,
        ...amSchoolTabs,
        ...brndTabs,
        ...cgRaveTabs,
        ...portfolio365Tabs,
        ...kiiidsArtTabs,
        ...dafesTabs,
        [NAVBAR_TAB_NAMES.studios]: {
            active: pathname.startsWith(LinkTo.studios),
            content: t('nav.studios'),
            target: '_self',
            linkTo: () => {
                if (isCompetitionDeziiign) {
                    return CreateExternalLinkTo.deziiign(LinkTo.studios);
                }
                return LinkTo.studios;
            },
        },
        [NAVBAR_TAB_NAMES.genres]: {
            content: t('nav.genres'),
            linkTo: LinkTo.tagCompetencies,
        },
        [NAVBAR_TAB_NAMES.authors]: {
            content: <ComingSoonTab>авторы</ComingSoonTab>,
            disabled: true,
        },
        [NAVBAR_TAB_NAMES.publishingHouse]: {
            content: <ComingSoonTab>издательства</ComingSoonTab>,
            disabled: true,
        },
        [NAVBAR_TAB_NAMES.coursesContinium]: {
            active: location.pathname === '/',
            disabled: true,
            content: <ComingSoonTab>курсы</ComingSoonTab>,
        },
        [NAVBAR_TAB_NAMES.my_books]: {
            content: t('nav.my_books'),
            linkTo: LinkTo.myBooks,
        },
        [NAVBAR_TAB_NAMES.portfolio]: isLMSHSE ? {
            content: t('nav.portfolio'),
            linkTo: process.env.REACT_APP_URL_HSEDESIGN_RU,
            target: '_self',
        } : isMediiiaArt ? {
            content: t('nav.portfolio'),
            linkTo: `/portfolio`,
        } : {
            active: location.pathname === '/',
            content: t('nav.portfolio'),
            linkTo: `/`,
        },
        [NAVBAR_TAB_NAMES.portfolio_deziiign_external]: {
            content: t('nav.portfolio'),
            linkTo: CreateExternalLinkTo.deziiign(),
            target: '_self',
        },
        [NAVBAR_TAB_NAMES.courses]: {
            disabled: isContinuumSite,
            content: t('nav.all_courses'),
            linkTo: '/',
        },
        [NAVBAR_TAB_NAMES.all_courses]: {
            content: t('nav.all_courses'),
            linkTo: '/',
        },
        [NAVBAR_TAB_NAMES.courses_offline]: {
            content: t('nav.offline_courses'),
            linkTo: '/courses_offline',
        },
        [NAVBAR_TAB_NAMES.courses_online]: {
            active: isLectureMediiia ? location.pathname === '/courses_online' || location.pathname === '/' : location.pathname === '/courses_online',
            content: t('nav.online_courses'),
            linkTo: '/courses_online',
        },
        [NAVBAR_TAB_NAMES.courses_lms]: {
            content: t('nav.courses'),
            external: true,
            linkTo: window.location.origin.includes("com") ? process.env.REACT_APP_URL_HSEDESIGN_LMS_COM : process.env.REACT_APP_URL_HSEDESIGN_LMS,
            target: '_self',
        },
        [NAVBAR_TAB_NAMES.courses_lmshse]: {
            content: t('nav.all_courses'),
            external: true,
            linkTo: window.location.origin.includes("com") ? process.env.REACT_APP_URL_HSEDESIGN_LMS_COM : process.env.REACT_APP_URL_HSEDESIGN_LMS,
            target: '_self',
        },
        [NAVBAR_TAB_NAMES.metrics]: {
            content: t('nav.metrics'),
            external: true,
            linkTo: `${process.env.REACT_APP_URL_HSEDESIGN_RU}/metrics`,
            target: '_self',
        },
        [NAVBAR_TAB_NAMES.custom_courses]: {
            content: t('nav.courses'),
            linkTo: '/lms',
        },
        ...tagTabs,
        [NAVBAR_TAB_NAMES.artpublishing]: {
            active: location.pathname === '/teams/artpublishing',
            content: t('nav.artpublishing'),
            linkTo: CreateExternalLinkTo.gallllery('/books?page=1'),
            target: '_blank',
        },
        [NAVBAR_TAB_NAMES.subscription]: {
            content: t('nav.subscription'),
            linkTo: '/teams/artpublishing/brnd',
        },
        [NAVBAR_TAB_NAMES.artists]: {
            linkTo: '/tag/category/12545e352cb24ab5985ecf9c084e47f6',
            content: t('nav.catalogs'),
        },
        [NAVBAR_TAB_NAMES.lms]: {
            content: t('nav.education'),
            linkTo: '/lms',
        },
        [NAVBAR_TAB_NAMES.people]: {
            content: t('nav.people'),
            active: location.pathname.startsWith('/context/hse/teachers') ||
                location.pathname.startsWith('/context/hse/students') ||
                location.pathname.startsWith('/context/hse/opa') ||
                location.pathname.startsWith('/context/hse/opa_by_month'),
            linkTo: '/context/hse/teachers',
        },
        [NAVBAR_TAB_NAMES.professors]: {
            content: t('nav.professors'),
            active: location.pathname.startsWith('/context/hse/teachers') ||
                location.pathname.startsWith('/context/hse/students') ||
                location.pathname.startsWith('/context/hse/opa') ||
                location.pathname.startsWith('/context/hse/opa_by_month'),
            linkTo: '/context/hse/teachers',
        },
        [NAVBAR_TAB_NAMES.students]: {
            content: t('nav.students'),
            active: location.pathname.startsWith('/context/hse/students'),
            linkTo: '/context/hse/students',
        },
        [NAVBAR_TAB_NAMES.publishers]: {
            content: t('nav.publishers'),
            linkTo: LinkTo.specialProjects,
        },
        [NAVBAR_TAB_NAMES.special_projects]: {
            linkTo: LinkTo.specialProjects,
            content: () => {
                if (isMediiiaEvents) {
                    return t('nav.special_projects_gifts')
                }
                if (isMediiiaUrban) {
                    return t('nav.special_projects_studios')
                }
                if (isMediiiaBooks) {
                    return t('nav.special_projects_books')
                }
                if (isMediiiaNature) {
                    return t('nav.special_projects_astro')
                }
                return t('nav.special_projects')
            },
        },
        [NAVBAR_TAB_NAMES.special_projects_main]: {
            content: t('nav.special_projects'),
            linkTo: '/',
        },
        [NAVBAR_TAB_NAMES.laboratory]: {
            active: pathname === '/laboratories',
            content: t('nav.laboratory').toLowerCase(),
            linkTo: () => {

                if (isProHSE) {
                    return process.env.REACT_APP_URL_HSEDESIGN_RU + `/laboratories`
                }

                return `/laboratories`
            },
            target: '_self',
        },
        [NAVBAR_TAB_NAMES.fantasy_sport]: {
            active: pathname === '/fantasy_sport',
            content: <ComingSoonTab>fantasy sport</ComingSoonTab>,
            disabled: true,
        },
        [NAVBAR_TAB_NAMES.lpu_awards]: {
            active: pathname === '/awards',
            content: <ComingSoonTab>awards</ComingSoonTab>,
            disabled: true,
        },
        [NAVBAR_TAB_NAMES.timeline]: {
            content: t("nav.timeline"),
            linkTo: '/timeline',
        },
        [NAVBAR_TAB_NAMES.gallllery]: {
            content: t("nav.gallllery"),
            linkTo: '/galleries',
        },
        [NAVBAR_TAB_NAMES.e_books]: {
            active: pathname === 'e_books' || (isBooksGallllery && window.location.pathname.endsWith('/')),
            content: (isAgeyTomesh || isHseAnimation || isContinuumSite) ? <ComingSoonTab>e-books</ComingSoonTab> : (isBooksGallllery ? t("nav.e_books") : "e-books"),
            linkTo: process.env.REACT_APP_URL_BOOKS_GALLLLERY,
            target: isDeziiignMain ? '_blank' : '_self',
            disabled: isAgeyTomesh || isHseAnimation || isContinuumSite
        },
        ...(!isBooksMain ? competitionTabs : {}),
        ...myCoursesTabs,
        ...shopTabs,
        [NAVBAR_TAB_NAMES.wallet]: {
            content: t('nav.wallet'),
            linkTo: process.env.REACT_APP_URL_WALLET,
            target: '_blank',
        },
        [NAVBAR_TAB_NAMES.partners]: {
            content: t('nav.partners'),
            linkTo: '/partners',
        },
        [NAVBAR_TAB_NAMES.fund]: {
            content: t('nav.fund'),
            linkTo: '/fund',
        },
        [NAVBAR_TAB_NAMES.festival]: {
            content: t('nav.festival'),
            linkTo: '/festival/Diploma25',
        },
        [NAVBAR_TAB_NAMES.map]: {
            active: Boolean(isMap),
            content: t('nav.map').toLowerCase(),
            linkTo: CreateLinkTo.map(
                bURL.saveVariablesToURIComponent({
                    display: "map",
                    force: true,
                })
            )
        },
        [NAVBAR_TAB_NAMES.competitionsForContinuum]: {
            content: <ComingSoonTab>конкурсы</ComingSoonTab>,
            active: false,
            disabled: true
        },
        [NAVBAR_TAB_NAMES.create_place]: {
            content: t('nav.create_place').toLowerCase(),
            linkTo: LinkTo.createLocation,
        },
        [NAVBAR_TAB_NAMES.sound_deziiign]: {
            content: "sound design",
            linkTo: 'https://design.hse.ru/dir/sound',
            target: '_blank',
        },
        [NAVBAR_TAB_NAMES.sound_lab]: {
            content: "sound lab",
            linkTo: 'https://design.hse.ru/lab/sounddesign#feedback',
            target: '_blank',
        },
        ...aboutTabs,
        [NAVBAR_TAB_NAMES.about_school]: isHSEDesign ? {
            content: t('nav.about_school'),
            linkTo: '/about_school',
        } : {
            content: isStartHSE ? t('nav.about_art_school') : t('nav.about_school'),
            linkTo: 'https://design.hse.ru/',
            external: true,
        },
        [NAVBAR_TAB_NAMES.about_ifcid]: {
            content: t('nav.about_ifcid'),
            active: false,
            linkTo: 'https://creative.hse.ru/',
            target: '_blank',
        },
        [NAVBAR_TAB_NAMES.made_on_media]: {
            content: t('nav.mediiia.made_by_mediiia'),
            linkTo: '/made_by_mediiia',
        },
        [NAVBAR_TAB_NAMES.coordinationCouncil]: {
            content: t('nav.coordinationCouncil'),
            linkTo: '/teams/dafes-council',
        },
        [NAVBAR_TAB_NAMES.news]: {
            content: t('nav.news'),
            linkTo: '/news',
        },
        [NAVBAR_TAB_NAMES.brands]: {
            content: t('nav.brands_simple'),
            linkTo: '/brands',
        },
        [NAVBAR_TAB_NAMES.residents]: {
            content: t('nav.residents'),
            linkTo: '/ud-residents',
        },
        [NAVBAR_TAB_NAMES.experts]: {
            content: t('nav.expert'),
            linkTo: '/ud-experts',
        },
        [NAVBAR_TAB_NAMES.education]: {
            content: t('nav.education'),
            linkTo: '/education',
        },
        [NAVBAR_TAB_NAMES.institutions]: {
            content: t('nav.institutions'),
            linkTo: '/institutions',
        },
        [NAVBAR_TAB_NAMES.partnerUniversities]: {
            active: pathname === '/teams/565f6fae5fcf4306a2ad9c85a3abe367' || pathname === '/partners',
            content: t('nav.partnerUniversities'),
            linkTo: '/partners',
        },
        [NAVBAR_TAB_NAMES.calendar]: {
            active: pathname === '/sport' || pathname === '/',
            content: t('nav.calendar'),
            linkTo: '/',
        },
        [NAVBAR_TAB_NAMES.professions]: {
            content: t('nav.professions'),
            linkTo: '/professions',
        },
        [NAVBAR_TAB_NAMES.sport_sports]: { // Бывший "темы"
            active: pathname === ('/sport/competencies') || pathname === ('/competencies'),
            content: t('nav.sports'),
            linkTo: '/competencies',
        },
        [NAVBAR_TAB_NAMES.sport_teams]: { // Бывший "теги"
            active: pathname === ('/sport/tags') || pathname === ('/tags'),
            content: t('nav.teams'),
            linkTo: '/tags',
        },
        [NAVBAR_TAB_NAMES.sport_leagues]: {
            active: pathname.startsWith('/teams') || pathname.startsWith('/leagues'),
            content: t('nav.leagues'),
            linkTo: '/leagues',
        },
        [NAVBAR_TAB_NAMES.sport_ratings]: {
            active: pathname.startsWith('/sport/ratings') || pathname.startsWith('/ratings'),
            content: t('nav.ratings'),
            linkTo: '/ratings',
        },
        [NAVBAR_TAB_NAMES.about_the_project]: {
            active: pathname.startsWith('/about_the_project'),
            content: <ComingSoonTab>{t('nav.about_project')}</ComingSoonTab>,
            disabled: true
        },
        [NAVBAR_TAB_NAMES.community]: {
            active: pathname.startsWith('/community'),
            content: <ComingSoonTab>{t('nav.community')}</ComingSoonTab>,
            disabled: true
        },
        [NAVBAR_TAB_NAMES.tracks_and_nominations]: {
            active: pathname === '/nominations' || pathname === '/',
            content: t('nav.tracks_and_nominations'),
            linkTo: '/nominations?tab=greenaward&page=1',
        },
        [NAVBAR_TAB_NAMES.results_of_previous_years]: {
            active: pathname.startsWith('/results'),
            content: t('nav.results_of_previous_years'),
            linkTo: '/results?tab=lastgreenaward&sorting=5&page=1',
        },

        [NAVBAR_TAB_NAMES.adcr_awards]: {
            active: pathname.startsWith('/awards'),
            content: t('nav.adcr_awards'),
            linkTo: '/awards?contexts=adcrawards',
        },
        [NAVBAR_TAB_NAMES.animation_awards]: {
            active: pathname.startsWith('/awards'),
            content: t('nav.awards_hsespace'),
            linkTo: 'https://hsedesign.ru/awards?page=1&tab=main_hse',
            target: '_self',
        },
        [NAVBAR_TAB_NAMES.club_members]: {
            content: t('nav.club_members'),
            linkTo: '/clubmembers',
        },
        [NAVBAR_TAB_NAMES.agencies_and_studios]: {
            content: t('nav.agencies_and_studios'),
            linkTo: '/studios',
        },
        [NAVBAR_TAB_NAMES.winners]: {
            content: t('nav.winners'),
            linkTo: '/winners',
        },
        [NAVBAR_TAB_NAMES.units]: {
            content: t('nav.units'),
            linkTo: isHseSpacePro ? `${process.env.REACT_APP_URL_HSE_SPACE}/units` : '/units',
        },
        [NAVBAR_TAB_NAMES.presentation]: {
            content: t('nav.presentation'),
            linkTo: CreateExternalLinkTo.hseSpace('/pro'),
            target: '_self'
        },
        [NAVBAR_TAB_NAMES.awardsHseSpace]: {
            content: t('nav.awards_hsespace'),
            linkTo:  isHseSpacePro ? `${process.env.REACT_APP_URL_HSE_SPACE}/awards` : '/awards',
        },
        [NAVBAR_TAB_NAMES.coursesHseSpace]: {
            active: pathname.startsWith('/courses'),
            content: t('nav.education'),
            linkTo: isHseSpacePro ? `${process.env.REACT_APP_URL_HSE_SPACE}/courses` : '/courses',
        },
        [NAVBAR_TAB_NAMES.categories]: {
            content: t('nav.categories'),
            linkTo: isHseSpacePro ? `${process.env.REACT_APP_URL_HSE_SPACE}/categories` : '/categories',
        },
        [NAVBAR_TAB_NAMES.books_gallllery]: {
            content: t('nav.books_gallllery'),
            linkTo: CreateExternalLinkTo.gallllery('/books?page=1'),
            target: '_self',
        },
        [NAVBAR_TAB_NAMES.calendars]: {
            active: false,
            external: true,
            content:
                <FlexBox align='center' style={{ paddingLeft: 0 }}>
                    <span style={{ marginRight: 2 }}>
                        {t('nav.calendars')}
                    </span>
                    <span style={{ transform: 'translateY(3px)' }}>↗</span>
                </FlexBox>
            ,
            linkTo: 'https://gallllery.com/365',
            target: '_blank',
        },
        [NAVBAR_TAB_NAMES.bookshops]: {
            content: t('nav.bookshops'),
            linkTo: '/bookshops',
        },
        [NAVBAR_TAB_NAMES.shop_gallllery]: {
            content: t('nav.shop'),
            linkTo: isMediiiaNature ? CreateExternalLinkTo.shopBrands('/?page=1&team=c3f512846d3b4a889f2d4f11a19fedf0') : CreateExternalLinkTo.gallllery('/books'),
            target: '_blank',
        },
        [NAVBAR_TAB_NAMES.sellers]: {
            content: t('nav.sellers'),
            linkTo: LinkTo.specialProjects,
        },
        [NAVBAR_TAB_NAMES.awards_booksgallery]: {
            active: pathname.startsWith('/awards'),
            content: t('nav.awards_hsespace'),
            linkTo: '/awards?contexts=/booksmediiiawards',
        },
        [NAVBAR_TAB_NAMES.deziiignresidents]: {
            active: pathname.startsWith('/teams/deziiignresidents'),
            content: t('nav.residents'),
            linkTo: () => {
                if (isCompetitionDeziiign) {
                    return CreateExternalLinkTo.deziiign('/teams/deziiignresidents');
                }
                return '/teams/deziiignresidents';
            },
            target: '_self',
        },
        [NAVBAR_TAB_NAMES.concept]: {
            content: t('nav.concept'),
            linkTo: '/concept',
        },
        [NAVBAR_TAB_NAMES.vacancies]: {
            active: false,
            content: <ComingSoonTab>{t('nav.vacancies')}</ComingSoonTab>,
            disabled: true,
        },
        [NAVBAR_TAB_NAMES.courses_lab]: {
            active: false,
            content: t('nav.courses_lab'),
            linkTo: CreateExternalLinkTo.deziiign('/courses')
        },
        [NAVBAR_TAB_NAMES.main_courses]: {
            active: pathname.startsWith('/courses'),
            content: isMediiia || isDeziiignMain ? t('nav.education') : t('nav.courses'),
            linkTo: '/courses',
        },
        [NAVBAR_TAB_NAMES.studios_deziiign]: {
            active: pathname === '/teams/7cb1b10a81a14667820120db9b9f334d',
            content: t('nav.studios'),
            linkTo: '/teams/7cb1b10a81a14667820120db9b9f334d',
        },
        [NAVBAR_TAB_NAMES.diplomas]: {
            active: pathname === '/teams/c0ac0a5cecf34bb5b30eea1d1d9ab721',
            content: t('nav.diplomas'),
            linkTo: '/teams/c0ac0a5cecf34bb5b30eea1d1d9ab721',
        },
        [NAVBAR_TAB_NAMES.about_hse_start]: {
            active: pathname === '/about',
            content: t('nav.about_hse_start'),
            linkTo: '/about',
        },
        [NAVBAR_TAB_NAMES.creative_exam]: {
            active: pathname === '/creativeexam',
            content: t('nav.creativeexam'),
            linkTo: '/creativeexam',
        },
        [NAVBAR_TAB_NAMES.admission_preparation]: {
            active: pathname === '/preparation',
            content: t('nav.preparation'),
            linkTo: '/preparation',
        },
        [NAVBAR_TAB_NAMES.opportunities]: {
            active: pathname === '/opportunities',
            content: t('nav.opportunities'),
            linkTo: '/opportunities',
        },
        [NAVBAR_TAB_NAMES.news_hse_start]: {
            active: pathname === '/startnews',
            content: t('nav.news'),
            linkTo: '/startnews',
        },
        [NAVBAR_TAB_NAMES.category_start_hse]: {
            active: pathname === '/tag/category/1cb7361e773b44899237d633ee9da5b5',
            content: t('nav.profiles_low'),
            linkTo: '/tag/category/1cb7361e773b44899237d633ee9da5b5',
        },
        [NAVBAR_TAB_NAMES.russiangallllery]: {
            active: pathname === '/russian',
            content: t('nav.russiangallllery'),
            linkTo: '/russian',
        },
        [NAVBAR_TAB_NAMES.awards_start]: {
            active: pathname === '/awards',
            content: <ComingSoonTab>{t('nav.competitions')}</ComingSoonTab>,
            linkTo: '/awards',
            disabled: true
        },
    }
}